import { Routes } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { ComingSoonComponent } from './coming-soon/coming-soon.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';

import { ServicesComponent } from './services/services.component';
import { AppDevelopmentComponent } from './services/app-development/app-development.component';
import { BlockchainComponent } from './services/blockchain/blockchain.component';
import { CallCenterComponent } from './services/call-center/call-center.component';
import { DataScienceComponent } from './services/data-science/data-science.component';
import { DigitalMarketingComponent } from './services/digital-marketing/digital-marketing.component';
import { DigitalMediaCenterComponent } from './services/digital-media-center/digital-media-center.component';
import { PublicityComponent } from './services/publicity/publicity.component';
import { SocialMediaComponent } from './services/social-media/social-media.component';
import { WebDevelopmentComponent } from './services/web-development/web-development.component';
import { BusinessIntelligenceComponent } from './services/business-intelligence/business-intelligence.component';
import { FintechComponent } from './services/fintech/fintech.component';

import { ClientsComponent } from './clients/clients.component';
import { CarajilloComponent } from './clients/carajillo/carajillo.component';
import { PixelMiningComponent } from './clients/pixel-mining/pixel-mining.component';
import { PernodRicardComponent } from './clients/pernod-ricard/pernod-ricard.component';
import { OrganizerStarComponent } from './clients/organizer-star/organizer-star.component';
import { MetaownComponent } from './clients/metaown/metaown.component';
import { LiverpoolComponent } from './clients/liverpool/liverpool.component';
import { LaTexanaComponent } from './clients/la-texana/la-texana.component';
import { JalomaComponent } from './clients/jaloma/jaloma.component';
import { FootballLegendsComponent } from './clients/football-legends/football-legends.component';
import { EvryComponent } from './clients/evry/evry.component';
import { EstrellaRealComponent } from './clients/estrella-real/estrella-real.component';
import { CitibanamexComponent } from './clients/citibanamex/Citibanamex';

export const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'muy-pronto', component: ComingSoonComponent },
    { path: 'mantenimiento', component: ComingSoonComponent },
    { path: 'inicio', component: HomeComponent },
    { path: 'acerca', component: AboutComponent },
    {
        path: 'servicios',
        children: [
            { path: '', component: ServicesComponent },
            {
                path: 'desarrollo-apps', component: AppDevelopmentComponent,
            },
            {
                path: 'blockchain', component: BlockchainComponent,
            },
            {
                path: 'call-center', component: CallCenterComponent,
            },
            {
                path: 'data-science', component: DataScienceComponent,
            },
            {
                path: 'digital-marketing', component: DigitalMarketingComponent,
            },
            {
                path: 'digital-media-center', component: DigitalMediaCenterComponent,
            },
            {
                path: 'publicidad', component: PublicityComponent,
            },
            {
                path: 'social-media', component: SocialMediaComponent,
            },
            {
                path: 'desarrollo-web', component: WebDevelopmentComponent,
            },
            {
                path: 'business-intelligence', component: BusinessIntelligenceComponent,
            },
            {
                path: 'fintech', component: FintechComponent,
            },
        ],
    },
    {
        path: 'clientes',
        children: [
            { path: '', component: ClientsComponent },
            {
                path: 'carajillo', component: CarajilloComponent,
            },
            {
                path: 'citibanamex', component: CitibanamexComponent,
            },
            {
                path: 'estrella-real', component: EstrellaRealComponent,
            },
            {
                path: 'evry', component: EvryComponent,
            },
            {
                path: 'football-legends', component: FootballLegendsComponent,
            },
            {
                path: 'jaloma', component: JalomaComponent,
            },
            {
                path: 'la-texana', component: LaTexanaComponent,
            },
            {
                path: 'liverpool', component: LiverpoolComponent,
            },
            {
                path: 'metaown', component: MetaownComponent,
            },
            {
                path: 'organizer-star', component: OrganizerStarComponent,
            },
            {
                path: 'pernod-ricard', component: PernodRicardComponent,
            },
            {
                path: 'pixel-mining', component: PixelMiningComponent,
            },
        ],
    },
    { path: 'contacto', component: ContactComponent },
    { path: 'privacidad', component: PrivacyPolicyComponent },
    { path: 'terminos', component: TermsOfServiceComponent },
];
